import http from '../api/http'

export default {
  list: () => http.get('/countries/list')
}



// WEBPACK FOOTER //
// ./src/services/countries.js